'use client'
import useScreenSize from '@/src/hooks/useScreenSize'
import { useEffect } from 'react'

const PopupScript = ({ length }: { length: number }) => {
  const { width } = useScreenSize()
  useEffect(() => {
    if (length === 0) return

    const updatePopupHeight = () => {
      const popupContainer = document.querySelector('.popup-container') as HTMLElement
      if (!popupContainer) return

      // 실제 팝업 컨테이너의 높이를 측정
      const actualHeight = popupContainer.offsetHeight

      if (actualHeight > 0) {
        document.body.style.setProperty('--popup', `${actualHeight}px`)
        return true
      }
      return false
    }

    // 즉시 한번 시도
    if (updatePopupHeight()) return

    // DOM이 완전히 렌더링될 때까지 기다리기 위해 MutationObserver 사용
    const observer = new MutationObserver(() => {
      if (updatePopupHeight()) {
        observer.disconnect()
      }
    })

    // 팝업 컨테이너가 존재할 때까지 감시
    const popupContainer = document.querySelector('.popup-container')
    if (popupContainer) {
      observer.observe(popupContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style'],
      })
    }

    // ResizeObserver도 추가하여 크기 변화 감지
    const resizeObserver = new ResizeObserver(() => {
      updatePopupHeight()
    })

    if (popupContainer) {
      resizeObserver.observe(popupContainer)
    }

    // 최대 1초 후에 강제로 한번 더 시도
    const timeoutId = setTimeout(() => {
      updatePopupHeight()
    }, 1000)

    // 클리너업
    return () => {
      observer.disconnect()
      resizeObserver.disconnect()
      clearTimeout(timeoutId)
    }
  }, [length, width])

  return <></>
}

export default PopupScript
